import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { ITripInfo } from '../../repositories/dailyrent/entities/response/TripInfo';
import { ENewReviewFlow, EStartReviewErrorCode } from '../../types/newReview';

export enum ECreateReviewDataActionTypes {
  Start = 'NEW_REVIEW/CREATE_REVIEW_DATA/START',
  Success = 'NEW_REVIEW/CREATE_REVIEW_DATA/SUCCESS',
  Error = 'NEW_REVIEW/CREATE_REVIEW_DATA/ERROR',
}

export interface ICreateReviewDataSuccessPayload {
  tripInfo: ITripInfo | null;
  flow: ENewReviewFlow | null;
}

export type TCreateReviewDataStart = ITypedReduxAction<ECreateReviewDataActionTypes.Start>;
export type TCreateReviewDataSuccess = ITypedReduxAction<
  ECreateReviewDataActionTypes.Success,
  ICreateReviewDataSuccessPayload
>;
export type TCreateReviewDataError = ITypedReduxAction<ECreateReviewDataActionTypes.Error, EStartReviewErrorCode>;

export type TCreateReviewDataActions = TCreateReviewDataStart | TCreateReviewDataSuccess | TCreateReviewDataError;

export const createReviewDataStart = actionGenerator<ECreateReviewDataActionTypes.Start>(
  ECreateReviewDataActionTypes.Start,
);
export const createReviewDataSuccess = actionGenerator<
  ECreateReviewDataActionTypes.Success,
  ICreateReviewDataSuccessPayload
>(ECreateReviewDataActionTypes.Success);
export const createReviewDataError = actionGenerator<ECreateReviewDataActionTypes.Error, EStartReviewErrorCode>(
  ECreateReviewDataActionTypes.Error,
);
